import {User} from "@/models/User";

export const USER_SERVICE_PROVIDER = Symbol("IUserService")

/**
 * Сервис для User
 */
export interface IUserService {
    /**
     * Получить пользователя по id
     * @param id
     */
    get(id: string): Promise<User | null>;

    /**
     * Заблокировать
     * @param legacyUserId
     */
    block(legacyUserId: string): Promise<void>;

    /**
     * Разблокировать
     * @param legacyUserId
     */
    unblock(legacyUserId: string): Promise<void>;

    /**
     * Сброс пароля по email
     * @param email
     */
    reset(email: string): Promise<void>;

    /**
     * Изменение пароля
     * @param id
     * @param password
     */
    change(id: string, password: string): Promise<void>;
}

